import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import inductionApi, { setInductionToken } from '../api/inductionAxios';
import logo from '../assets/logo.js';

const label = { display:'block', fontSize:'11px', fontWeight:'500', textTransform:'uppercase', letterSpacing:'.5px', color:'var(--muted)', marginBottom:'5px' };
const input = { width:'100%', background:'var(--surface)', border:'1px solid var(--border-md)', borderRadius:'var(--radius)', padding:'9px 12px', fontSize:'14px', color:'var(--text)', outline:'none' };

// Public page the worker lands on from the invite email
export default function InductionAccess() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [show,     setShow]     = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      const { data } = await inductionApi.post('/login', { username: username.trim(), password });
      setInductionToken(data.token);
      navigate('/induction-access/form', { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || 'Could not sign in. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px', fontFamily:'Inter,sans-serif' }}>
      <div style={{ width:'100%', maxWidth:'380px' }}>
        <div style={{ textAlign:'center', marginBottom:'28px' }}>
          <div style={{ width:'64px', height:'64px', background:'#000', borderRadius:'50%', margin:'0 auto 14px', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <img src={logo} alt="Car Saloon" style={{ width:'56px', height:'56px', objectFit:'contain' }}/>
          </div>
          <h1 style={{ fontSize:'20px', fontWeight:'600', color:'var(--text)', margin:0 }}>Staff Induction</h1>
          <p style={{ fontSize:'13px', color:'var(--muted)', marginTop:'4px' }}>Sign in with the temporary login from your email</p>
        </div>

        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'24px', boxShadow:'var(--shadow)' }}>
          {error && (
            <div style={{ background:'var(--red-bg)', border:'1px solid rgba(163,45,45,0.2)', borderRadius:'var(--radius)', padding:'10px 14px', color:'var(--red)', fontSize:'13px', marginBottom:'16px', display:'flex', gap:'8px' }}>
              <i className="ti ti-alert-circle" style={{ flexShrink:0, marginTop:'1px' }} aria-hidden="true"/>
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom:'14px' }}>
              <label style={label}>Username</label>
              <input value={username} onChange={e=>setUsername(e.target.value)} required autoFocus
                autoCapitalize="none" autoCorrect="off" spellCheck={false}
                placeholder="cs-xxxxxx" style={{ ...input, fontFamily:'JetBrains Mono,monospace' }}/>
            </div>
            <div style={{ marginBottom:'20px' }}>
              <label style={label}>Password</label>
              <div style={{ position:'relative' }}>
                <input type={show?'text':'password'} value={password} onChange={e=>setPassword(e.target.value)} required
                  autoCapitalize="none" autoCorrect="off" spellCheck={false}
                  style={{ ...input, paddingRight:'40px', fontFamily:'JetBrains Mono,monospace' }}/>
                <button type="button" onClick={()=>setShow(s=>!s)}
                  style={{ position:'absolute', right:'10px', top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--hint)', display:'flex', padding:'4px' }}>
                  <i className={`ti ${show?'ti-eye-off':'ti-eye'}`} style={{ fontSize:'16px' }} aria-label={show?'Hide password':'Show password'}/>
                </button>
              </div>
            </div>
            <button type="submit" disabled={loading}
              style={{ width:'100%', padding:'11px', background:loading?'var(--hint)':'var(--blue)', border:'none', borderRadius:'var(--radius)', color:'#fff', fontSize:'14px', fontWeight:'500', cursor:loading?'not-allowed':'pointer' }}>
              {loading ? 'Signing in...' : 'Open induction form'}
            </button>
          </form>
        </div>

        <p style={{ textAlign:'center', color:'var(--hint)', fontSize:'11px', marginTop:'20px' }}>
          This login only opens your induction form and expires 24 hours after it was sent.
        </p>
      </div>
    </div>
  );
}
